angular.module('autoremind.templates')
    .directive('previewEditTemplateAr2', ['templateAr2Service', 'dialogs', '$timeout', 'userSettings',
    function (templateAr2Service, dialogs, $timeout, userSettings) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/preview-edit-template-ar2.html',
            link: function (scope, elem, attr) {
                scope.userSettings = userSettings;
                scope.templateAr2Service = templateAr2Service;
                scope.viewModel = {
                    templateSource: false,
                    templateHtmlSource: '',
                    isEdited: false,
                    htmlChanged: false,
                    xmlChanged: false,
                    isNotSupported: false,
                    loadingIndicator: {
                        refCount: 0,
                        state: false
                    },
                    activeTabIndex: 0,
                    tabIndexes: {
                        preview: 0,
                        html: 1,
                        source: 2
                    },
                    isAsCustom: false,
                    customTemplateName: {
                        path: '',
                        name: '',
                        isFileNameValid: true,
                        isCanBeEdited: templateAr2Service.userModel.userId ? true : false
                    },
                    isChanged: false,
                    isCustomTemplate: false,
                    template: {
                        templateId: scope.template.sourceOfTemplate ? scope.template.sourceOfTemplate.templateId : null,
                        type: scope.template.type ? scope.template.type : 'email',
                        languageId: scope.template.sourceOfTemplate ? scope.template.sourceOfTemplate.languageId : null,
                        displayName: scope.template.sourceOfTemplate && scope.template.sourceOfTemplate.displayName ? scope.template.sourceOfTemplate.displayName : '',
                        templateName: scope.template.sourceOfTemplate ? scope.template.sourceOfTemplate.templateName : null
                    }
                };
                scope.editorXMLOptions = {
                    lineWrapping: userSettings.model.lineWrapping,
                    lineNumbers: true,
                    readOnly: false,
                    theme: 'default',
                    mode: 'xml',
                    formatting: false,
                    onLoad: function (cm) {
                        $timeout(function () {
                            cm.refresh();
                        }, 100, false);
                        //the second time is for to ensure that it would be loaded
                        $timeout(function () {
                            cm.refresh();
                        }, 500, false);
                    }
                };
                scope.editorHTMLOptions = {
                    lineWrapping: userSettings.model.lineWrapping,
                    lineNumbers: true,
                    readOnly: false,
                    theme: 'default',
                    mode: 'xml',
                    htmlMode: true,
                    formatting: false,
                    onLoad: function (cm) {
                        $timeout(function () {
                            cm.refresh();
                        }, 100, false);
                        //the second time is for to ensure that it would be loaded
                        $timeout(function () {
                            cm.refresh();
                        }, 500, false);
                    }
                };
                scope.$watch('userSettings.model.lineWrapping', function () {
                    scope.editorHTMLOptions.lineWrapping = userSettings.model.lineWrapping;
                    scope.editorXMLOptions.lineWrapping = userSettings.model.lineWrapping;
                });
                console.log('previewEditTemplateAr2', scope.template);
                scope.escapeXmlChars = function (str) {
                    // TODO: Check if it will cause conflicts with autoremind server if replacing quote and apostrophe (it seems the current templates are encoded using & and ' inside the <html> element
                    if (typeof (str) == "string") {
                        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); //.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
                    }
                    else {
                        return str;
                    }
                };
                scope.unescapeXmlChars = function (str) {
                    // TODO: Check if it will cause conflicts with autoremind server if replacing quote and apostrophe (it seems the current templates are encoded using & and ' inside the <html> element
                    return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>') /*.replace(/&quot;/g, '"').replace(/&apos;/g, "'") */.replace(/&amp;/g, '&');
                };
                scope.insertHtmlInXml = function () {
                    var escaped = scope.escapeXmlChars(scope.viewModel.templateHtmlSource);
                    var header = scope.viewModel.templateSource.substr(0, scope.viewModel.templateSource.indexOf('<html>') + 6);
                    var footer = scope.viewModel.templateSource.substr(scope.viewModel.templateSource.indexOf('</html>'), scope.viewModel.templateSource.length);
                    scope.viewModel.templateSource = header + escaped + footer;
                    //Do not refactor this, because str.replace have a problems with char '$', it trying to replace the '$' to the group
                    // TODO: Refactor this to parse XML and replace html element rather than manually manipulating document?
                    //scope.viewModel.templateSource = scope.viewModel.templateSource.replace(/<html>[\s\n\r\S]+<\/html>/, "<html>" + escaped + "</html>");
                };
                scope.getHtmlFromXml = function (xmlString) {
                    // TODO: Refactor this to parse XML and get html element rather than using RegExp for parsing the xml?
                    var html = xmlString.match(/<html>[\s\n\r\S]+<\/html>/);
                    if (html) {
                        var escaped = html.toString().replace(/<\/?html>/g, '');
                        scope.viewModel.templateHtmlSource = scope.unescapeXmlChars(escaped);
                    }
                };
                scope.selectTab = function (tabName) {
                    scope.viewModel.activeTabIndex = scope.viewModel.tabIndexes[tabName];
                    // The following selections are only possible if type is email, so no need to check for that
                    if ((tabName === 'preview' || tabName === 'html') && scope.xmlChanged) {
                        scope.xmlChanged = false;
                        scope.getHtmlFromXml(scope.viewModel.templateSource);
                    }
                    else if ((tabName === 'source') && scope.viewModel.htmlChanged) {
                        scope.viewModel.htmlChanged = false;
                        scope.insertHtmlInXml();
                    }
                };
                scope.templateSourceChanged = function () {
                    console.log('templateSourceChanged', scope.viewModel);
                    scope.viewModel.isEdited = true;
                    scope.xmlChanged = true;
                };
                scope.templateHtmlSourceChanged = function () {
                    console.log('templateSourceChanged', scope.viewModel);
                    scope.viewModel.isEdited = true;
                    scope.viewModel.htmlChanged = true;
                };
                scope.init = function () {
                    if (!angular.isDefined(scope.template) || !scope.template.fileName) {
                        return;
                    }
                    scope.templateAr2Service.getXmlTemplateForPreview(scope.template.fileName, scope.viewModel.loadingIndicator)
                        .then(function (data) {
                        if (!angular.isDefined(data.source)) {
                            return;
                        }
                        scope.viewModel.xmlChanged = false;
                        scope.viewModel.htmlChanged = false;
                        scope.viewModel.templateSource = data.source;
                        if (scope.template.type === 'email') {
                            scope.getHtmlFromXml(scope.viewModel.templateSource);
                        }
                    }, function (error) {
                        scope.cancel();
                    });
                }();
                scope.checkPath = function () {
                    var requestData = {
                        templateName: scope.template.sourceOfTemplate.templateName,
                        type: scope.template.sourceOfTemplate.type,
                        language: scope.template.sourceOfTemplate.languageId
                    };
                    requestData.fileName = scope.viewModel.customTemplateName.path + scope.viewModel.customTemplateName.name;
                    scope.templateAr2Service.checkpathandtemplatename(requestData)
                        .then(function (res) {
                        scope.viewModel.customTemplateName.isFileNameValid = !res.pathExist;
                    }, function (err) {
                    });
                };
                if (scope.template.sourceOfTemplate && angular.isDefined(scope.template.sourceOfTemplate.countOfTemplateFileUsages) && scope.template.sourceOfTemplate.countOfTemplateFileUsages > 0) {
                    scope.viewModel.isAsCustom = true;
                    scope.viewModel.customTemplateName.path = templateAr2Service.userModel.userId + '/'; //scope.template.fileName.substr( 0, scope.template.fileName.lastIndexOf('/')+1 );
                    scope.viewModel.customTemplateName.name = scope.template.fileName.substr(scope.template.fileName.lastIndexOf('/') + 1);
                    scope.checkPath();
                }
                scope.saveTemplate = function () {
                    console.log('saveTemplate, 0', scope.viewModel.templateSource);
                    if (scope.viewModel.htmlChanged) {
                        scope.viewModel.htmlChanged = false;
                        // Update source to include edited html - before saving
                        scope.insertHtmlInXml();
                    }
                    var templateData = {
                        fileName: scope.template.fileName,
                        content: scope.viewModel.templateSource,
                        isCustomTemplate: scope.viewModel.isAsCustom,
                        isChanged: scope.viewModel.isChanged,
                        template: scope.viewModel.template
                    };
                    console.log('saveTemplate', templateData);
                    scope.templateAr2Service.saveTemplate(templateData)
                        .then(function (data) {
                        scope.viewModel.isEdited = false;
                        scope.success({ template: data.template, isCustomTemplate: scope.viewModel.isAsCustom });
                    });
                };
                scope.registerAsCustomTemplate = function () {
                    if (scope.viewModel.htmlChanged) {
                        scope.viewModel.htmlChanged = false;
                        // Update source to include edited html - before saving
                        scope.insertHtmlInXml();
                    }
                    var templateData = {
                        fileName: scope.viewModel.customTemplateName.path + scope.viewModel.customTemplateName.name,
                        content: scope.viewModel.templateSource,
                        isCustomTemplate: scope.viewModel.isAsCustom,
                        isChanged: scope.viewModel.isChanged,
                        template: scope.viewModel.template,
                        userId: templateAr2Service.userModel.userId ? templateAr2Service.userModel.userId : 0
                    };
                    scope.templateAr2Service.saveTemplate(templateData)
                        .then(function (data) {
                        scope.viewModel.isEdited = false;
                        scope.success({ template: data.template, isCustomTemplate: scope.viewModel.isAsCustom });
                    });
                };
                scope.cancelEditing = function () {
                    if (!scope.viewModel.isEdited) {
                        scope.cancel();
                        return;
                    }
                    dialogs.confirm('Cancel editing', 'You have unsaved data that will be lost. Are you sure you want to discard the changes?')
                        .result.then(function () {
                        scope.cancel();
                    });
                };
                var _timeout;
                scope.fileNameWasChanged = function () {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        scope.checkPath();
                    }, 1000);
                };
                scope.templateWasChanged = function () {
                    scope.viewModel.isChanged = true;
                };
            }
        };
    }]);
//# sourceMappingURL=preview-edit-template-ar2.directive.js.map